import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useUserType } from './UserTypeContext';
import { Icon } from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";


// My components
// import { LoginForm } from "../../components/common/LoginForm";

// My css
import css from "../../css/common/login-form.module.css";
import regisCss from "../../css/user/regis-page.module.css";

// import logo from "../../assets/images/yuva_logo.png";
import { SERVER_ORIGIN } from "../../utilities/constants";
import SecCard from "../../components/common/SecCard";
import { getApiStatusText } from "../../utilities/helper_functions";

// todo: validation of creds on frontend side

///////////////////////////////////////////////////////////////////////////////////////////////////////////
const SetPasswordPage = () => {
    // const [modal, setModalOpen] = useState(false);
    // const [form, setForm] = useState({
    //     // userId: "",
    //     password: "",
    //     userId: "",

    // });
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confPassword, setConfPassword] = useState('');
    const [passwordsMatch, setPasswordsMatch] = useState(true); // State to track password match
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [emailSuccess, setEmailSuccess] = useState(false);
    const navigate = useNavigate();
    const [creds, setCreds] = useState({ userId: "", password: "" });
    const updateCreds = (e) => {
        setCreds((prevCreds) => {
            const newCreds = { ...prevCreds, [e.target.name]: e.target.value };
            // (newCreds);

            return newCreds;
        });
    };
    const [isUserTypeAvailable, setIsUserTypeAvailable] = useState(false)
    const { userType, setUserTypeToAdmin, setUserTypeToUser, setUserTypeToInstitute, setUserTypeToChapterEM, setUserTypeToRegionEM } = useUserType();

    useEffect(() => {
        if (!userType) {
            setIsUserTypeAvailable(false)
        }
        if (!isUserTypeAvailable) {
            const urlParams = new URLSearchParams(window.location.search);
            let typeParam = urlParams.get('userType');

            if (typeParam === 'admin') {
                setUserTypeToAdmin()
                // userType = typeParam;
                // console.log(typeParam, userType);
            }
            if (typeParam === 'student') {
                setUserTypeToUser()
                // userType = typeParam;
                // console.log(typeParam, userType);
            }
            if (typeParam === 'institute') {
                setUserTypeToInstitute()
                // userType = typeParam;
                // console.log(typeParam, userType);
            }
            if (typeParam === 'em') {
                setUserTypeToChapterEM()
                // userType = typeParam;
                // console.log(typeParam, userType);
            }
            if (typeParam === 'regionem') {
                setUserTypeToRegionEM()
                // userType = typeParam;
                // console.log(typeParam, userType);
            }
        }
        // if (userType === "student") {
        //     setCreds({ userId: "", password: "" });
        // } else if (userType === "institute") {
        //     setCreds({ instituteEmail: "", password: "" });
        // } else if (userType === "em") {
        //     setCreds({ email: "", password: "" });
        // }

    }, [userType]);
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setPasswordsMatch(event.target.value === confPassword); // Check if passwords match
    };

    const handleConfPasswordChange = (event) => {
        setConfPassword(event.target.value);
        setPasswordsMatch(event.target.value === password); // Check if passwords match
    };
    function handleModalClose() {
        navigate('/')
        // setModalOpen(false);
        setEmailSuccess(false);
    }

    async function handleSubmitClick() {
        // const { isValid, desc } = isRegisFormValid(regisForm);
        if (!passwordsMatch) {
            toast.error("Password Does Not Match");
            return;
        }

        try {
            // setIsRegistering(true);
            // setIsBtnDisabled(true);
            const userId = "utkarsh@troology.in";
            const userPassword = "Redhood@23"
            //  const basicAuth = btoa(`${userId}:${userPassword}`);
            let bodyParam;
            let URLParam;
            if (userType === "student") { bodyParam = "userId"; URLParam = "student"; }
            else if (userType === "institute") { bodyParam = "instituteEmail"; URLParam = "institute"; }
            else if (userType === "em") { bodyParam = "email"; URLParam = "em"; }
            else if (userType === "regionem") { bodyParam = "email"; URLParam = "regionem"; }

            const response = await fetch(
                `${SERVER_ORIGIN}/api/${userType}/auth/set-pwd`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        //Authorization: `Basic ${basicAuth}`,
                    },
                    body: JSON.stringify({ [bodyParam]: email, 'password': confPassword }),
                }
            );

            const result = await response.json();

            if (response.status >= 400 && response.status < 600) {
                if (response.status === 500) {
                    toast.error(getApiStatusText(result));
                } else if (response.status === 403) {
                    // response.errors.map(elem => {
                    return toast.error(getApiStatusText(result));
                    // })
                }
            }
            // else if (response.ok && response.status === 200) {
            //     toast.success("Set password successfully, you can login now"); // registered therefore regis btn remains disabled
            //     // navigate(`/login?userType=${userType}`);
            //     console.log("dshdhshdga",result);
            //     const isThalir = result?.isThalir;

            //     if (userType === "institute") {
            //         if (isThalir) {
            //             navigate(`/thalir-login?userType=${userType}`);
            //         } else {
            //             navigate(`/yuva-login?userType=${userType}`);
            //         }
            //     } else {
            //         // fallback for other user types
            //         navigate(`/login?userType=${userType}`);
            //     }

            // } else {
            //     // for future
            // }
            else if (response.ok && response.status === 200) {
                toast.success("Set password successfully, you can login now");

                console.log("API RESULT:", result);

                if (userType === "em") {
                    navigate(`/yuva-login?userType=em`);
                }

                else if (userType === "regionem") {
                    const regionEMfor = result?.regionEMfor;

                    if (regionEMfor === "YUVA") {
                        navigate(`/yuva-login?userType=regionem`);
                    } else if (regionEMfor === "THALIR") {
                        navigate(`/thalir-login?userType=regionem`);
                    } else {
                        toast.error("Invalid regionEMfor value");
                    }
                }

                else if (userType === "institute") {
                    const isThalir = result?.isThalir;

                    if (isThalir) {
                        navigate(`/thalir-login?userType=institute`);
                    } else {
                        navigate(`/yuva-login?userType=institute`);
                    }
                }

                else {
                    navigate(`/login?userType=${userType}`);
                }
            }
        } catch (err) {
            console.log(err.message);
            // setIsBtnDisabled(false); // can reclick on register btn
        }
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const emailParam = urlParams.get('email');
        const userTypeParam = urlParams.get('userType');

        if (emailParam) {
            // Properly decode the URL encoded email
            const decodedEmail = decodeURIComponent(emailParam);
            setEmail(decodedEmail);
        }
        // if (userTypeParam) {
        //     setUserType(userTypeParam);
        // }


        // Cleanup on unmount or when isAPIHitted changes
    }, []);

    return (
        <div className={`${regisCss.verifyouterDiv} ${regisCss.outerDiv}`}>
            <SecCard>
                <div >
                    <p className={css.passHeading}>Set Password</p>
                    <div>
                        <div>
                            <div className="d-grid" style={{ marginBottom: "0.8rem" }}>
                                <label className={regisCss.regisLabel} htmlFor="email">
                                    Email <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="Email"
                                    placeholder="E-mail"
                                    className={css.forgotPassInput}
                                    value={email}
                                    readOnly // Make the input field read-only to prevent manual editing
                                />
                            </div>
                            <div className="d-grid" style={{ marginBottom: "0.8rem" }}>
                                <label className={regisCss.regisLabel} htmlFor="password">
                                    Password <span style={{ color: "red" }}>*</span>
                                </label>
                                <div style={{ position: "relative", width: "90%" }}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        id="password"
                                        placeholder="Enter Password"
                                        className={css.forgotPassInput}
                                        style={{ width: "100%", paddingRight: "2.6rem" }}
                                        value={password}
                                        onChange={handlePasswordChange}
                                    />
                                    <span
                                        onClick={() => setShowPassword((prev) => !prev)}
                                        style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                                    >
                                        <Icon icon={showPassword ? eye : eyeOff} size={20} />
                                    </span>
                                </div>
                            </div>
                            <div className="d-grid" style={{ marginBottom: "0.8rem" }}>
                                <label className={regisCss.regisLabel} htmlFor="confpassword">
                                    Confirm Password <span style={{ color: "red" }}>*</span>
                                </label>
                                <div style={{ position: "relative", width: "90%"}}>
                                    <input
                                        type={showConfPassword ? "text" : "password"}
                                        name="Confirm Password"
                                        id="confpassword"
                                        placeholder="Enter Confirm Password"
                                        className={css.forgotPassInput}
                                        style={{ width: "100%", paddingRight: "2.6rem" }}
                                        value={confPassword}
                                        onChange={handleConfPasswordChange}
                                    />
                                    <span
                                        onClick={() => setShowConfPassword((prev) => !prev)}
                                        style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                                    >
                                        <Icon icon={showConfPassword ? eye : eyeOff} size={20} />
                                    </span>
                                </div>
                                {!passwordsMatch && <p style={{ color: "red", marginTop: "0.2rem" }}>Passwords do not match</p>}
                            </div>
                        </div>
                        <div style={{
                            border: '2px dashed #cccccc',
                            padding: '1rem',
                            // textAlign: 'center',
                            cursor: 'pointer',
                            width: '90%',
                            backgroundColor: '#f5f5f5'
                        }}>
                            <p>Make sure the password contains:</p>
                            <ul>
                                <li>Minimum 8 characters</li>
                                <li>At least one uppercase letter</li>
                                <li>At least one lowercase letter</li>
                                <li>At least one number</li>
                                <li>At least one special character</li>
                            </ul>
                        </div>
                        <div className={css.forgotPassBtnWrapper}>
                            <button
                                className={css.forgotPassCancelBtn}
                                onClick={handleModalClose}
                            >
                                Cancel
                            </button>
                            <button
                                className={css.forgotPassBtn}
                                onClick={handleSubmitClick}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </SecCard>
        </div>
    );
};

export default SetPasswordPage;
